(function($) {
  new Swiper('.room-carousel-main', {
    loop: true,
    spaceBetween: 15,
    slidesPerView: 1,
    autoplay: true,
    navigation: {
      prevEl: '.room-carousel-main__navigation-prev',
      nextEl: '.room-carousel-main__navigation-next'
    },
    thumbs: {
      swiper: {
        el: '.room-carousel-thumbs',
        loop: false,
        slidesOffsetBefore: 15,
        slidesOffsetAfter: 15,
        slidesPerView: 'auto',  
        spaceBetween: 15,
        freeMode: true
      }
    },
    watchSlidesProgress: true,
    watchSlidesVisibility: true
  })

  new Swiper('.room-relate-carousel', {
    loop: true,
    loopedSlides: 6,
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 48,
    navigation: {
      prevEl: '.room-relate-carousel__navigation-prev',
      nextEl: '.room-relate-carousel__navigation-next'
    }
  })
})(jQuery);